import React, {useEffect} from 'react';
import {View} from 'react-native';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import BreadCrumbsWeb from 'components/organisms/breadCrumbsWeb';
import NavigationHeaderWebTabs from 'components/organisms/navigationHeaderWebTabs/index.web';
import NavigationHeaderWeb from 'components/organisms/navigationWeb';
import {Flows, ScreenName} from 'navigations/Screens';
import {createNavigationAnalyticsInfo} from 'navigations/TabBar';
import TranscriptionsChatList from 'components/molecules/transcriptionsChatList';
import {useAnalyticsStore} from 'contexts/StoreContext';
import {AnalyticsScreenProps} from 'navigations/AnalyticsFlow';
import styleSheet from './styles';

const TranscriptionsScreen = observer((props: AnalyticsScreenProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const analyticsStore = useAnalyticsStore();

  let stack = createNavigationAnalyticsInfo(theme);

  useEffect(() => {
    const prefetchData = async () => {
      await analyticsStore.getTranscriptionAnalytics(props.route.params?.id);
    };

    prefetchData();
  }, []);

  return (
    <View style={styles.container}>
      <NavigationHeaderWeb activeName={Flows.analyticsFlow} />
      <BreadCrumbsWeb />
      <NavigationHeaderWebTabs
        navigationStack={stack}
        activeName={ScreenName.transcriptions}
        backgroundColor={styles.navigationBackground}
        sessionId={props.route.params?.id}
      />
      <View style={styles.listContainer}>
        <TranscriptionsChatList
          flatListData={analyticsStore.transcriptionChatData}
        />
      </View>
    </View>
  );
});

export default TranscriptionsScreen;
